<template>
  <div class="main-menu">
    <!-- <router-view /> -->
    <component :is="currentMenuComponent" :arrow="arrow"></component>
  </div>
</template>

<script>
import MainMenuOption from "@/components/popupMenu/MenuOptions.vue";
import PersonalArea from "@/components/personalArea/PersonalAreaMainMenu.vue";
import PersonalAreaDiskVer from "@/components/personalArea/PersonalAreaVersionInfo.vue";
import PersonalAreaContact from "@/components/personalArea/PersonalAreaContact.vue";
import MenuSettings from "@/components/popupMenu/MenuOptions/setting/MainSetting.vue";
import BookList from "@/components/popupMenu/MenuOptions/setting/BookListSetting.vue";
import MenuLang from "@/components/popupMenu/MenuOptions/setting/LanguageSetting.vue";
import advSettingsMenu from "@/components/popupMenu/MenuOptions/setting/AdvSettings.vue";
import MenuDisplay from "@/components/popupMenu/MenuOptions/setting/DisplaySetting.vue";
import MareiMekomot from "@/components/popupMenu/MenuOptions/setting/MareiMekomot.vue";
import MenuTools from "@/components/popupMenu/MenuOptions/tools/MainTools.vue";
import MenuHistory from "@/components/popupMenu/MenuOptions/tools/historyLists/History.vue";
import MenuHiddenBooks from "@/components/popupMenu/MenuOptions/tools/hiddenBooks/MenuHiddenBooks.vue";
import MenuMyProfile from "@/components/popupMenu/MenuOptions/MenuMyProfile.vue";
import MenuSavePersonalData from "@/components/popupMenu/MenuOptions/MenuSavePersonalData.vue";
import MenuLoginSubUser from "@/components/popupMenu/MenuOptions/MenuLoginSubUser.vue";
import MenuCreateSubUser from "@/components/popupMenu/MenuOptions/MenuCreateSubUser.vue";
import MenuChangePassword from "@/components/popupMenu/MenuOptions/MenuChangePassword.vue";
import MenuMyLicense from "@/components/popupMenu/MenuOptions/MenuMyLicense.vue";
import MenuWhatsNew from "@/components/popupMenu/MenuOptions/help/MenuWhatsNew.vue";
import MenuPersonalExten from "@/components/popupMenu/MenuOptions/tools/personalExtensions/PersonalExtensions.vue";
import MenuDesktop from "@/components/popupMenu/MenuOptions/tools/DesktopSettings.vue";
import MenuBooksInfo from "@/components/popupMenu/MenuOptions/tools/changeBookInfo/BooksInfoSettingsBooksList.vue";
import MenuBookInfoEdit from "@/components/popupMenu/MenuOptions/tools/changeBookInfo/BookInfoSettings.vue";
import MenuExten from "@/components/popupMenu/MenuOptions/extensions/MainExtensions.vue";
import MenuHelp from "@/components/popupMenu/MenuOptions/help/MainHelp.vue";
import MenuHelpDocs from "@/components/popupMenu/MenuOptions/help/ShowHelp.vue";
import MenuDocuments from "@/components/popupMenu/MenuOptions/help/ShowDocuments.vue";
import MenuAboutApp from "@/components/popupMenu/MenuOptions/help/About.vue";
import MenuLicenceCode from "@/components/popupMenu/MenuOptions/help/LicenseCode.vue";
import MenuReportBug from "@/components/popupMenu/MenuOptions/reportingBugs/ReportingBugs.vue";
import MenuContact from "@/components/popupMenu/MenuOptions/contact/Contact.vue";
import MenuContactInfo from "@/components/popupMenu/MenuOptions/contact/ContactStaffList.vue";
import MenuDesktops from "@/components/popupMenu/MenuOptions/tools/DesktopSettings.vue";
import MenuUserComments from "@/components/popupMenu/MenuOptions/tools/personalExtensions/CommentsPopup.vue";
import MenuKeysPopup from "@/components/popupMenu/MenuOptions/tools/personalExtensions/KeysPopup.vue";
import MenuMarkersPopup from "@/components/popupMenu/MenuOptions/tools/personalExtensions/MarkersPopup.vue";
import viewSymbolContainerVue from "../popupFolders/contentFolder/modeViewFolders/viewSymbolContainer.vue";
import menuBackup from "@/components/popupMenu/MenuOptions/tools/menuBackup.vue";
import MenuSupport from "@/components/popupMenu/MenuOptions/menuSupport.vue";
import networkComputerMenu from "@/components/popupMenu/MenuOptions/network/networkComputerMenu.vue";
import menuShortCuts from "@/components/popupMenu/MenuOptions/tools/menuShortCuts.vue";
import menuOpenBook from "@/components/popupMenu/MenuOptions/tools/menuOpenBook.vue";
import menuAppUpdates from "@/components/popupMenu/MenuOptions/tools/menuAppUpdates.vue";
import MenuDisconnectSettings from "@/components/popupMenu/MenuOptions/MenuDisconnectSettings.vue";
import PersonalAreaPrivateInfo from "../personalArea/PersonalAreaPrivateInfo.vue";
import PersonalAreaEditForm from "../personalArea/PersonalAreaEditForm.vue";
import PersonalAreaExtensions from "../personalArea/PersonalAreaExtensions.vue";
import PersonalAreaConvertDiskOnline from "../personalArea/PersonalAreaConvertDiskOnline.vue";
import PersonalAreaAllMessages from "../personalArea/PersonalAreaAllMessages.vue";
import PdfDpiSettings from "@/components/popupMenu/MenuOptions/tools/pdfDpi/PdfDpiSettings.vue";
export default {
  props: {
    arrow: { default: true },
  },
  computed: {
    currentMenuComponent() {
      let current = this.$store.state.menu.currentMenu;

      switch (current) {
        case "disconnectSettings":
          return MenuDisconnectSettings;
        case "createSubUser":
          return MenuCreateSubUser;
        case "loginSubUser":
          return MenuLoginSubUser;
        case "savePersonalData":
          return MenuSavePersonalData;
          break;
        case "changePassword":
          return MenuChangePassword;
        case "myProfile":
          return MenuMyProfile;
          break;
        case "shortcuts":
          return menuShortCuts;
          break;
        case "app-updates":
          return menuAppUpdates;
          break;
        case "openbook":
          return menuOpenBook;
          break;
        case "advSettingsMenu":
          return advSettingsMenu;
        case "myLicense":
          return MenuMyLicense;
        case "whatsNew":
          return MenuWhatsNew;
          break;
        case "hiddenbooks":
          return MenuHiddenBooks;
          break;
        case "settings":
          return MenuSettings;
        case "tools":
          return MenuTools;
        case "help":
          return MenuHelp;
        case "bugs":
          return MenuReportBug;
        case "contact":
          return MenuContact;
        case "contact-list":
          return MenuContactInfo;
        case "exten":
          return MenuExten;
        case "lang":
          return MenuLang;
        case "display":
          return MenuDisplay;
        case "mm":
          return MareiMekomot;
        case "booklist":
          return BookList;
        // case "daily-backup":
        //   return MenuBackup;
        case "books":
          return MenuBooksInfo;
        case "books-edit":
          return MenuBooksInfo;
        case "history":
          return MenuHistory;
        case "desktops":
          return MenuDesktops;
        case "personal-exten":
          return MenuPersonalExten;
        case "personal-keys":
          return MenuKeysPopup;
        case "personal-marks":
          return MenuMarkersPopup;
        case "personal-comments":
          return MenuUserComments;
        case "about-app":
          return MenuAboutApp;
        case "lic-app":
          return MenuLicenceCode;
        case "help-docs":
          return MenuHelpDocs;
        case "documents":
          return MenuDocuments;
        case "backup":
          return menuBackup;
        case "book-settings":
          return MenuBookInfoEdit;
        case "support":
          return MenuSupport;
        case "main":
        default:
          return MainMenuOption;
        case "network":
          return networkComputerMenu;
        case "personal-area-mainmenu":
          return PersonalArea;
        case "personal-area-diskver":
          return PersonalAreaDiskVer;
        case "personal-area-contact":
          return PersonalAreaContact;
        case "personal-area-privateinfo":
          return PersonalAreaPrivateInfo;
        case "personal-area-editform":
          return PersonalAreaEditForm;
        case "personal-area-ext":
          return PersonalAreaExtensions;
        case "personal-area-convert-disk-online":
          return PersonalAreaConvertDiskOnline;
        case "personal-area-messages":
          return PersonalAreaAllMessages;
        case "dpi-settings":
          return PdfDpiSettings;
      }
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$bg-color1: #fff;
.main-menu {
  overflow: auto;
  z-index: 6;
  margin: 0;
  padding: 0;
  display: flex;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 323px;
  background-color: $bg-color1;
  box-shadow: 10px 0 10px rgba(0, 0, 0, 0.16);
  animation: menu_show 0.3s;
  transition: 0.3s;
}
@keyframes menu_show {
  from {
    transform: translateX(-100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
